module["exports"] = [
  "تهران",
  "مشهد",
  "اصفهان",
  "کرج",
  "تبریز",
  "شیراز",
  "اهواز",
  "قم",
  "کرمانشاه",
  "ارومیه",
  "رشت",
  "زاهدان",
  "کرمان",
  "اراک",
  "همدان",
  "یزد",
  "اردبیل",
  "بندرعباس",
  "اسلام‌شهر",
  "زنجان",
  "قزوین",
  "سنندج",
  "خرم‌آباد",
  "گرگان",
  "ساری",
  "ملارد",
  "قدس",
  "کاشان",
  "گلستان",
  "شهریار",
  "دزفول",
  "خمینی‌شهر",
  "بروجرد",
  "نیشابور",
  "سبزوار",
  "نجف‌آباد",
  "آمل",
  "بابل",
  "ورامین",
  "آبادان",
  "پاکدشت",
  "خوی",
  "ساوه",
  "بجنورد",
  "قائم‌شهر",
  "بوشهر",
  "قرچک",
  "سیرجان",
  "بیرجند",
  "ایلام"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/address/city_name.js
// module id = 2899
// module chunks = 1610